import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import numeral from 'numeral';
import Cleave from 'cleave.js/react';

import DateRangePicker from 'react-bootstrap-daterangepicker';

import '../../stylesheets/daterangepicker.css';

import BlankState from '../../components/BlankState';
import StatusMessages2 from '../../components/StatusMessages2';
import Modal from '../../components/Modal';
import Panel from '../../components/Panel';
import StatusMessages from '../../components/StatusMessages';

import LocalDB from '../../utils/localDB';
import Utils from '../../utils/mci-utils';
import { revisedPremiumCalculation } from '../../utils/calculations';
import { translations } from '../../i18n/translations';

import { quoteSignIn } from '../../actions/user';
import { saveQuote } from '../../actions/policy';

class Shipment extends Component {
  constructor(props) {
    super(props);

    this.state = LocalDB.fetch('mci_form');
  }

  componentDidUpdate() {
    if (!this.props.user.userInfo == null) {
      window.location.reload();
    }
  }

  componentDidMount() {
    let intermediary = {};

    if (this.state.selected_agency !== '') {
      intermediary = this.state.selected_agency;
    }

    if (this.state.selected_broker !== '') {
      intermediary = this.state.selected_broker;
    }

    let {
        conveyance,
        containerised,
        selected_goods,
        transshipment,
        selected_insurer,
        warehousing,
        currency_rate,
        other_rates,
        icc_class
      } = this.state,
      premium = revisedPremiumCalculation(
        selected_insurer,
        selected_goods,
        conveyance,
        containerised,
        transshipment,
        warehousing,
        currency_rate.rate,
        other_rates,
        icc_class
      );

    this.setState({
      intermediary,
      duration_of_cover: 90,
      premium,
      date_created: new Date().now,
      username: '',
      password: '',
      proposer_name: '',
      email: '',
      phone: '',
      tra_pin: '',
      start_date: new Date(),
      error: false
    });

    console.log(this.state.start_date);
  }

  onChange = e => {
    e.preventDefault();

    const { name, value } = e.target;

    this.setState({
      [name]: value
    });
  };

  onSignIn = e => {
    e.preventDefault();
    this.props.quoteSignIn(this.state.username, this.state.password);
  };

  resetForm = () => {
    this.setState({ error: false });
  };

  onGoToNext = e => {
    e.preventDefault();
    this.resetForm();

    const { proposer_name, email, phone, tra_pin, selected_goods } = this.state;

    if (
      proposer_name === '' ||
      email === '' ||
      phone === '' ||
      tra_pin === ''
    ) {
      this.setState({
        errorMessage: 'Please fill in all the required details',
        error: true
      });
    } else {
      let goods = [];

      selected_goods.map(good => {
        return goods.push({
          quantity: parseFloat(good.quantity),
          unit_qty: good.unit_of_measure,
          premium_rate: null,
          description: good.goods_description,
          section: good.section_id,
          cfr: parseFloat(good.cfr)
        });
      });

      const quote = {
        duration_of_cover: this.state.duration_of_cover,
        institute_cargo_clause: this.state.icc_class,
        corporate_client: null,
        agent: null,
        broker: null,
        insurer: this.state.selected_insurer.insurer,
        bank: null,
        total_sum_insured: this.state.premium.total_cfr,
        premium: parseInt(this.state.premium.premium, 10),
        total_cfr: this.state.premium.total_cfr,
        policy_number: '',
        pcf: 0,
        insurance_training_levy: this.state.premium.itl,
        gross_direct_premium: Math.round(
          this.state.premium.gross_direct_premium
        ),
        premium_rate: this.state.selected_insurer.id,
        date_created: moment(this.state.date_created).format('YYYY-MM-DD'),
        proposer_name: this.state.proposer_name,
        start_date: moment(this.state.start_date).format('YYYY-MM-DD'),
        town_to: this.state.destination.id,
        country_of_origin: this.state.origin.id,
        country_from: this.state.origin.id,
        country_to: 'ef70adbe-b34b-4eaa-8ab1-a61ad79dad98',
        port_to: this.state.entry_port.id,
        currency_rate_used: this.state.currency_rate.id,
        conveyance_used: this.state.conveyance,
        transhipment: this.state.transhipment,
        stamp_duty: 0,
        notes: '',
        insured_data: {
          email: this.state.email,
          name: this.state.proposer_name,
          phone_number: this.state.phone
        },
        port_from: '',
        is_open_cover: false,
        buy_on_behalf: false,
        is_credit: false,
        is_transhipment: false,
        is_warehousing: false,
        is_taxes: false,
        tra_pin: this.state.tra_pin,
        packaging: this.state.containerised,
        creator: null,
        flight_number: this.state.flight_number || null,
        policy_type: this.state.transaction_type,
        intermediary: this.state.intermediary.id,
        quote_goods: goods
      };

      this.props.saveQuote(quote);
    }
  };

  render() {
    console.log(this.state);

    let {
        conveyance,
        origin,
        destination,
        entry_port,
        currency_rate,
        transaction_type,
        packaging,
        transshipment,
        warehousing,
        other_rates,
        selected_goods,
        selected_insurer,

        icc_class,

        proposer_name,
        email,
        phone,
        tra_pin
      } = this.state,
      cost_of_goods = Utils.sum(selected_goods, 'goods_value'),
      premium = revisedPremiumCalculation(
        selected_insurer,
        selected_goods,
        conveyance,
        packaging,
        transshipment,
        warehousing,
        currency_rate.rate,
        other_rates,
        icc_class
      ).premium;

    const { policy } = this.props;
    return (
      <div className="row cover-details">
        <div className="col-sm-4">
          <Panel title={translations.shipment}>
            <dl>
              <dt>Transaction:</dt>
              <dd>{transaction_type}</dd>
            </dl>
            <dl>
              <dt>ICC Class:</dt>
              <dd>{icc_class}</dd>
            </dl>
            <dl>
              <dt>Packaging:</dt>
              <dd>{packaging || '-'}</dd>
            </dl>
            <dl>
              <dt>Sum Insured:</dt>
              <dd>
                {currency_rate.currency_code +
                  ' ' +
                  numeral(cost_of_goods).format('0,0.00')}
              </dd>
            </dl>
            <dl>
              <dt>Premium:</dt>
              <dd>
                {translations.currency +
                  ' ' +
                  numeral(premium).format('0,0.00')}
              </dd>
            </dl>
            <dl>
              <dt>Conveyance:</dt>
              <dd>{Utils.getConveyanceType(conveyance) || '-'}</dd>
            </dl>
            <dl>
              <dt>Country of Export:</dt>
              <dd>{origin.country || '-'}</dd>
            </dl>
            <dl>
              <dt>Destination:</dt>
              <dd>{destination.town || '-'}</dd>
            </dl>
            <dl>
              <dt>Point of Entry:</dt>
              <dd>{entry_port.port || '-'}</dd>
            </dl>

            <dl>
              <dt>Trans-shipment:</dt>
              <dd>{transshipment ? 'Yes' : 'No'}</dd>
            </dl>
            <dl>
              <dt>Warehousing:</dt>
              <dd>{warehousing ? 'Yes' : 'No'}</dd>
            </dl>
            <dl>
              <dt>Broker:</dt>
              <dd>{'-'}</dd>
            </dl>
          </Panel>
        </div>

        <div className="col-sm-8">
          <Panel title={translations.service_provider}>
            <div className="row">
              <div className="col-sm-3">
                <img
                  src={selected_insurer.insurer_logo}
                  alt="[IMG]"
                  className="img-responsive"
                  style={{ border: '1px solid #ddd' }}
                />
              </div>
              <div className="col-sm-9">
                <h3>{selected_insurer.insurer_name}</h3>
              </div>
            </div>
          </Panel>

          <table className="table table-bordered">
            <thead>
              <tr>
                <th width="75%">{translations.goods}</th>
                <th className="text-right">
                  {translations.cost} ({currency_rate.currency_code})
                </th>
              </tr>
            </thead>
            <tbody>
              {selected_goods.length !== 0 ? (
                selected_goods.map((good, index) => {
                  return (
                    <tr key={index}>
                      <td>{good.section_name}</td>
                      <td className="text-right">
                        {numeral(good.cfr).format('0,0.00')}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="3">
                    <div className="alert alert-warning">
                      No goods added yet
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <Panel title="Insured Details">
            <div className="form-horizontal">
              <div className="form-group">
                <div className="col-sm-offset-4 col-sm-6">
                  {this.state.error ? (
                    <div className="alert alert-danger">
                      {this.state.errorMessage}
                    </div>
                  ) : null}
                  {policy.createQuoteLoading ? (
                    <BlankState
                      data={false}
                      customMessage="Creating quote..."
                      isDataLoading={policy.createQuoteLoading}
                    />
                  ) : (
                    <StatusMessages2
                      type="error"
                      message={
                        policy.errorMessageCreateQuote !== undefined
                          ? policy.errorMessageCreateQuote
                          : ''
                      }
                    />
                  )}
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-4 control-label">
                  Insured's Name <span className="text-danger">*</span>
                </label>
                <div className="col-sm-6">
                  <input
                    className="form-control"
                    type="text"
                    name="proposer_name"
                    required
                    autoFocus
                    value={proposer_name}
                    onChange={this.onChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-4 control-label">
                  Email Address <span className="text-danger">*</span>
                </label>
                <div className="col-sm-6">
                  <input
                    className="form-control"
                    name="email"
                    type="email"
                    required
                    value={email}
                    onChange={this.onChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-4 control-label">
                  Phone Number <span className="text-danger">*</span>
                </label>
                <div className="col-sm-6">
                  <input
                    className="form-control"
                    type="text"
                    name="phone"
                    required
                    value={phone}
                    onChange={this.onChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-4 control-label">
                  TRA PIN <span className="text-danger">*</span>
                </label>
                <div className="col-sm-6">
                  <Cleave
                    options={{
                      blocks: [3, 3, 4],
                      delimiter: '-',
                      numericOnly: true
                    }}
                    className="form-control"
                    name="tra_pin"
                    id="tra_pin"
                    type="text"
                    validations={['required']}
                    value={tra_pin}
                    onChange={this.onChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="col-sm-4 control-label">Cover Starts</label>
                <div className="col-sm-6">
                  <DateRangePicker
                    locale={{ format: 'YYYY-MM-DD' }}
                    minDate={moment()}
                    singleDatePicker={true}
                    onApply={e => {
                      this.onChange(e);
                    }}
                  >
                    <input
                      name="start_date"
                      type="text"
                      className="form-control date-picker-control full-width"
                      onChange={this.onChange}
                      required
                      placeholder="Start from date..."
                    />
                  </DateRangePicker>

                  <p className="text-info">
                    {translations.duration_of_cover} is 90 days
                  </p>
                </div>
              </div>
            </div>
          </Panel>

          <div className="clearfix">
            <hr />
            <button
              className="btn btn-warning"
              onClick={() => {
                window.history.back();
              }}
            >
              <span className="glyphicon glyphicon-menu-left" />{' '}
              {translations.btn_back}
            </button>
            <button
              className="btn btn-success pull-right"
              onClick={this.onGoToNext}
            >
              {translations.btn_next}{' '}
              <span className="glyphicon glyphicon-menu-right" />
            </button>
          </div>
        </div>

        <Modal
          closable={false}
          defaultOpen={true}
          title={'Login to continue...'}
          className="login-modal"
        >
          {this.props.user.modalError ? (
            <StatusMessages
              type="fail"
              message={this.props.user.errorMessage.error}
            />
          ) : null}

          <form className="sign-in" onSubmit={this.onFormSubmit}>
            <input
              type="text"
              name="username"
              className="form-control"
              placeholder="Username or Email Address"
              onChange={this.onChange}
              value={this.state.username}
              required
              autoFocus
            />

            <input
              type="password"
              name="password"
              className="form-control"
              placeholder="Password"
              onChange={this.onChange}
              value={this.state.password}
              required
            />
          </form>

          <button className="btn btn-warning" onClick={this.onSignIn}>
            Login
          </button>
        </Modal>
        <button
          ref="loginToggle"
          className="hidden"
          data-toggle="modal"
          data-target=".login-modal"
          data-backdrop="static"
          data-keyboard="false"
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  policy: state.policy
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ saveQuote, quoteSignIn }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Shipment);



// WEBPACK FOOTER //
// ./src/pages/buy/Shipment.jsx